import { FC } from 'react';
import { Spin } from 'antd';

interface LoadingSpinnerProps {
  message: string;
}

const LoadingSpinner: FC<LoadingSpinnerProps> = ({ message }) => {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <Spin size="large" />
      <div style={{ marginTop: '16px', color: '#666' }}>{message}</div>
    </div>
  );
};

export default LoadingSpinner;